
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/event/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/event/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/event/[[...pathParams]]"])
      });
    }
  